import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { TimeDetailBus } from './TimeDetailBus';
import { CommonValues } from '../static/CommonValues';
import { setValue } from '@datorama/akita';

export class NoTimeForPersonDetailBus extends BaseBus
{
    CID() : any {
        return this.payrollNoTimeId;
    }
    setEmptyGuidToNull = false;
    constructor(data: NoTimeForPersonDetailBus = null) {
        super(data);

        this.noTimeUpdated = false;
    if (data !== undefined && data !== null) {

        this.workDate = CommonFunctions.getDate(data.workDate);
        this.workDateAdj = new Date(this.workDate.getTime() + 13 * 60 * 60 * 1000);
    }
  }

    payrollNoTimeId: string;
    noTimeTypeId: string;
    workDate: Date;
    otherText: string;
    noTimeApproved: boolean;
    approveUserId: string;
    noTimeUpdated:boolean
    workDateAdj: Date;

    }

